import appStore from "@/store/app.store";
import { getClientVersion } from "./window";

export const getVersion = async () => {
  const version = await getClientVersion();
  appStore.getState().setCurrentVersion(version);
  return version;
};
